/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../services/supplier_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import {
  getSupplierCategorySelection,
  getSupplierList,
} from "../../../redux/feature/supplier_app/supplierSlice";
import { addCategorySelectedData } from "../../../redux/feature/supplier_app/supplierSlice";

//Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import DataTable from "react-data-table-component";
import Constants from "../../../common/SupplierConstants";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";
import ApproveRemarksModal from "../../../Components/Modal/supplier_app/ApproveRemarksModal";
import CategorySelectionModal from "../../../Components/Modal/supplier_app/CategorySelectionModal";
import toast from "react-hot-toast";
import SuccessModal from "../../../Components/Modal/supplier_app/SuccessModal";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import { ComboboxFieldSubArray } from "../../../Components/formElements/ComboboxFieldSubArray";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";

const VendorDetailedPageWorkflow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let selectedCategoryData = useSelector(
    (state) => state?.supplier?.selectedCategory
  ); // User Details from Store
  let userInfo = useSelector((state) => state?.user?.data); // userInfo from Store
  let supplierData = useSelector((state) => state?.supplier?.data); // supplierData from Store
  let supplierID = useSelector((state) => state?.supplier?.supplierID); // supplierID from Store
  let workflow = useSelector((state) => state?.supplier?.workflow); // supplierID from Store

  localStorage.setItem("menu", workflow?.page);
  localStorage.setItem("submenu", "-");

  let pageSection = ["CategorySelection"];

  // Format the price above to USD using the locale, style, and currency.
  // let USDollar = new Intl.NumberFormat("en-US", {
  //   style: "currency",
  //   currency: "USD",
  // });

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");
  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  let dropdownOption = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  const [data, setData] = useState([]);
  const [initalData, setInitalData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisible11, setCardVisible11] = useState(true);
  const [isCardVisible12, setCardVisible12] = useState(true);
  const [isCardVisible13, setCardVisible13] = useState(true);
  const [isCardVisible14, setCardVisible14] = useState(true);
  const [isCardVisible15, setCardVisible15] = useState(true);
  const [isCardVisible16, setCardVisible16] = useState(true);
  const [isCardVisible17, setCardVisible17] = useState(true);

  const [getDropdownData, setDropdownData] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowCat, setModalShowCat] = useState(false);
  const [getSelectedData, setSelectedData] = useState([]);
  const [getDisabledRemove, setDisabledRemove] = useState(true);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibility11 = () => {
    setCardVisible11(!isCardVisible11);
  };
  const toggleCardVisibility12 = () => {
    setCardVisible12(!isCardVisible12);
  };
  const toggleCardVisibility13 = () => {
    setCardVisible13(!isCardVisible13);
  };
  const toggleCardVisibility14 = () => {
    setCardVisible14(!isCardVisible14);
  };
  const toggleCardVisibility15 = () => {
    setCardVisible15(!isCardVisible15);
  };
  const toggleCardVisibility16 = () => {
    setCardVisible16(!isCardVisible16);
  };
  const toggleCardVisibility17 = () => {
    setCardVisible17(!isCardVisible17);
  };
  /* Modal Function */
  const addCategorySelection = () => {
    setModalShowCat(true);
  };
  const hideModalCat = () => {
    setModalShowCat(false);
  };

  // get SelectedCatData
  const getSelectedCatData = (data) => {
    // console.log(">> getSelectedCatData ", data);
    setInitalData(data);
    setModalShowCat(false);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const [formInputs, setFormInputs] = useState({
    organisationName: "",
    companyName: "",
    email: "",
    firstName: "",
    lastName: "",
    roles: ["VENDOR"],
    category: ["VENDOR"],
    address: "",
    address2: "",
    city: "",
    countryCode: "",
    country: "",
    stateRegion: "",
    regionCode: "",
    cityPostalCode: "",
    contactTitle: "",
    contactNumber: "",
    contactfirstName: "",
    contactlastName: "",
    contactEmail: "",
    contactPhoneNr: "",
    companyOwner: "",
    companyLogo: "",
    CompanyBrochure: "",
    natureOfBusiness: "",
    commodityServices: "",
    haveICVCertificate: "",
    paymentsTerm: "",
    nameOwer: "",
    icvScore: "",
    icvCertificate: "",
    icvExpiryDate: "",
    vatRegistrationNumber: "",
    vatRegistrationExpiryDate: "",
    tradeLicenseNumber: "",
    tradeLicenseExpiryDate: "",
    BCMPlanPolicy: "",
    dealershipSetupType: "",
    MROcommoditybrand: "",
    brandName: "",
    OverseasTaxRegistrationNumber: "",
    issuingAuthorityAccreditation: "",
    chamberIncorporationCertificate: "",
    chamberIncorporationExpiryDate: "",
    humanRightsIssue: {
      HarassmentPolicy: "",
      ChildLabourPolicy: "",
      ForcedLabourPolicy: "",
      WorkingHoursPolicy: "",
      DiscriminationAtWorkPolicy: "",
      FreedomOfAssociationPolicy: "",
      CommuncationFullyUnderstood: "",
      ConflictMineralsIndigenousPeople: "",
    },
    financialDetails: {
      turnover1: "",
      turnover2: "",
    },
    categorySpecificInformation: {
      havingIso17025: "",
      safetyReqs: "",
      iso45001certificate: "",
      iso9001certificate: "",
      iso14001certificate: "",
      PoAinstituteIssued: "",
      isHseManagementManual: "",
      haveHseAuditProcedure: "",
      haveSkillTrainingSystem: "",
    },
    responsibleSourcing: {
      haveWrittenCodeOfConduct: "",
      alignedWithScComplianceEthics: "",
      haveWrittenRiskAssesProcessInSc: "",
      involvedInLocalCommunityProjects: "",
      haveWrittenPolicyOnAntiCorruption: "",
    },
    environmentalStewardship: {
      biodiversity: "",
      energyConsumption: "",
      wasteGeneration: "",
      climateChange: "",
      waterConsumption: "",
    },
    bankDetails: [],
    contactDetails: [
      {
        lastName: "",
        firstName: "",
        contactEmail: "",
        contactTitle: "",
        contactNumber: "",
        contactPosition: "",
      },
    ],
  });

  // Don't remove this
  const contactAddressData = {
    lastName: "",
    firstName: "",
    contactEmail: "",
    contactTitle: "",
    contactNumber: "",
    contactPosition: "",
  };

  const bankInfoInitialData = {
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    iban: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",
  };

  const [getBankDetails, setBankDetails] = useState([]);
  const [getContactAddress, setContactAddress] = useState([]);

  const [disabled, setDisabled] = useState(false);
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const [getBankDetailsData, setBankDetailsData] = useState([]);
  const [getJobTitleData, setJobTitleData] = useState([]);
  const [getContactTitleData, setContactTitleData] = useState([]);
  const [getCountry, setCountry] = useState([]);
  const [getState, setState] = useState([]);
  const [getAction, setAction] = useState("");
  const [getPageBlockStatus, setPageBlockStatus] = useState(false);
  const [getdocumentType, setdocumentType] = useState([]);


  const newProject = {
    projectCode: 1,
    projectCodeDesc: "PROJECT_1",
    projectName: "",
    projectAddress: "",
    projectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karanataka",
    projectCityPostalCode: "",
    getProjectContactPerson: [
      {
        id: Date.now(), // Unique ID for the first contact person
        projectContactPosition: "",
        projectContactTitle: "",
        projectContactName: "",
        projectContactNumber: "",
        projectContactEmail: "",
      },
    ],
    getProjectCertifications: [
      {
        id: Date.now(),
        name: "Document 1",
        documentType: "",
        certificateCode: "29AADCN1012B1Z6",
        stageDocument: "",
      },
    ],
    getLocations: [],
  };
  let productDocumentAttachment = [
    {
      id: "1",
      name: "Stage1",
    },
    {
      id: "2",
      name: "Stage2",
    },
    {
      id: "3",
      name: "Stage3",
    },
    {
      id: "4",
      name: "Stage4",
    },
    {
      id: "5",
      name: "Stage5",
    },

    {
      id: "6",
      name: "Google Pin location",
    },
    {
      id: "7",
      name: "Project Photos",
    },
    {
      id: "8",
      name: "Blueprints or Layout Plans",
    },
    {
      id: "9",
      name: "Project Document",
    },
    {
      id: "10",
      name: "Others",
    },
  ];
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);
  const [getProjectDetails, setProjectDetails] = useState([newProject]);
  const [nextId, setNextId] = useState(1); // Start IDs from 1
  const [getCertificateData, setCertificateData] = useState();

  const handleBankInfo = (index, key, value) => {
    alert("need to validate");
  };

  const handleChangeBankInfo = (index, key, value) => {
    if (value) {
      const newForms = [...getBankDetails];
      newForms[index][key] = value;
      setBankDetails(newForms);
      // console.log(">> newForms", newForms);

      if (key === "bankKey") {
        // eslint-disable-next-line array-callback-return
        getBankDetailsData.filter((item) => {
          if (item.bankKey === value) {
            const newForms = [...getBankDetails];
            newForms[index]["bankCountryDescription"] =
              item.bankCountryDescription;
            newForms[index]["bankAccountName"] = item.bankAccountName;
            newForms[index]["bankAddress"] = item.bankAddress;
            newForms[index]["bankBranchName"] = item.bankBranchName;
            newForms[index]["bankCurrency"] = item.bankCurrency;
            setBankDetails(newForms);
          }
        });
      }
    }
  };
  // Bank Info Section ends

  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">> data ss", getDropdownData);
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
      getStateData(getDropdownData?.code);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
      getBankMasterData(); // Load Bank Details
      getMasterData(); // Load Master Data
    }
    return () => {
      isMounted = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadFirstLevelData = async () => {
    setLoading(true);
    if (supplierID) {
      let obj = {
        userId: supplierID,
      };

      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      await ItemService.getUserDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          setDisabledStatus(true);
          setFormInputs(item.data);
          setInitalData(item.data?.vendorCategory);
          setCertificateData(item?.data?.certifications);

          item.data?.bankDetails
            ? setBankDetails(item.data?.bankDetails)
            : setBankDetails([...getBankDetails, bankInfoInitialData]);
          item.data?.contactDetails
            ? setContactAddress(item.data?.contactDetails)
            : setContactAddress([...getContactAddress, contactAddressData]);
          // item.data?.projectDetails
          //   ? setProjectDetails(item.data?.projectDetails)
          //   : setProjectDetails(...getProjectDetails);
          item.data?.projectDetails
            ? setProjectDetails(item.data.projectDetails)
            : setProjectDetails(getProjectDetails);

          item.data?.documentTypeData
            ? setDocumentTypeData(item?.data?.documentTypeData)
            : setDocumentTypeData(...getDocumentTypeData)

          // console.log(">>setProjectDetails",setProjectDetails)
          setLoading(false);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });
    } else {
      navigate(Constants.INBOX);
    }
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Datatables
  const fetchUsers = async () => {
    setLoading(true);
    // console.log(">> selectedCategoryData", selectedCategoryData);

    setData((prevItems) => {
      // Remove items from prevItems that are not in newItems
      const filteredPrevItems = prevItems.filter((item) => {
        return selectedCategoryData.some(
          (newItem) => newItem.CategoryCode === item.CategoryCode
        );
      });
      // Merge filteredPrevItems with newItems (add new items or update existing ones)
      const updatedItems = [
        ...filteredPrevItems.map(
          (item) =>
            selectedCategoryData.find(
              (newItem) => newItem.CategoryCode === item.CategoryCode
            ) || item
        ),
        ...selectedCategoryData.filter(
          (newItem) =>
            !filteredPrevItems.some(
              (item) => item.CategoryCode === newItem.CategoryCode
            )
        ),
      ];
      return updatedItems;
    });

    // setTotalRows(selectedCategoryData?.length);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(); // fetch page 1 of users
    // console.log(">> data", data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategoryData]);

  const columns = [
    {
      name: "Category Code",
      selector: (row) => row.vendorCategoryCode || "--",
      sortable: true,
      width: "250px",
    },
    {
      name: "Category",
      selector: (row) => row.vendorCategoryText || "--",
      sortable: true,
      width: "280px",
    },

    {
      name: "SubCategory",
      selector: (row) => row.vendorSubCategoryText || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "SubCategory Code",
      selector: (row) => row.vendorSubCategoryCode || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "SubCategory Description",
      selector: (row) => row.vendorSubCategoryLongText || "--",
      sortable: true,
      width: "400px",
    },
  ];

  const companyDocumentsCol = [
    {
      name: "Name",
      selector: (row) => row.name || "--",
      sortable: true,
      width: "250px",
    },
    {
      name: "Document Type",
      selector: (row) => row.documentType || "--",
      sortable: true,
      width: "280px",
    },

    {
      name: "Document Number",
      selector: (row) => row.documentNumber || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Expiration Date",
      selector: (row) => row.expirationDate || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Issuing Authority",
      selector: (row) => row.issuingAuthority || "--",
      sortable: true,
      width: "400px",
    },
    {
      name: "Certificate Code",
      selector: (row) => row.certificateCode || "--",
      sortable: true,
      width: "400px",
    },
  ];

  const handleChange = ({ selectedRows }) => {
    // console.log(">> selectedRows ", selectedRows);
    if (selectedRows?.length > 0) {
      setDisabledRemove(false);
    } else {
      setDisabledRemove(true);
    }
    setSelectedData(selectedRows);
  };

  const removeCategory = () => {
    const updatedInitialValue = initalData.filter(
      (item) => !getSelectedData.some((selected) => selected._id === item._id)
    );
    setInitalData(updatedInitialValue);
    setDisabledRemove(true);
  };

  //Load Bank Master Data
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setBankDetailsData(item?.data);
      } else {
        setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setJobTitleData(item?.data);
      } else {
        setJobTitleData([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj1 = {
      codeType: "title",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setContactTitleData(item?.data);
      } else {
        setContactTitleData([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj0 = {
      codeType: "country",
    };
    await ItemService.getMasterData(obj0).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const navigateToWorkflow = () => {
    if (workflow?.page === "Inbox") {
      navigate(Constants.INBOX);
    } else {
      navigate(Constants.OUTBOX);
    }
  };

  const showApproveModal = async (name) => {
    setModalShow(true);
    setAction(name);
  };

  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;
    obj.data = {
      vendorCategory: data.length === 0 ? initalData : data,
    };
    let newObj = { ...bodyObj, ...obj };

    console.log("newObj", newObj)

    //Approve
    await ItemService.workflowApproveReject(newObj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        successModalData.successMsg = "Successfully " + getAction;
        setsucceModalData(successModalData);
        setNextNavigate(Constants.INBOX);
        onSuccessmodel();
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };

  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const hasCommonValues = pageSection.some((item) =>
        workflow?.workflow_record?.editSection?.includes(item)
      );
      if (hasCommonValues) {
        if (workflow?.workflow_record?.editForm) {
          setPageBlockStatus(true);
        }
      }
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflow]);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const onSuccessUploadfiles = (data) => {
    setFormInputs((prevData) => ({
      ...prevData,
      [data.fieldName]: data.attachmentId,
    }));
  };


  /* ---------------------project details block-------- */
  const addProjectDetails = () => {
    newProject.projectCode = nextId + 1;
    newProject.projectCodeDesc = "PROJECT_" + (nextId + 1);
    setProjectDetails((prevData) => [...prevData, newProject]);
    setNextId((prevId) => prevId + 1);
  };

  const removeProjectDetails = (indexToRemove) => {
    setProjectDetails(
      getProjectDetails.filter((_, idx) => idx !== indexToRemove)
    );
  };

  const handleProjectInputChange = (value, index, fieldName) => {
    // console.log(">>handleProjectInputChange", { index, fieldName, value });

    if (index === undefined || value === undefined) return;

    // Update the specific project detail
    setProjectDetails((prevDetails) =>
      prevDetails.map((item, idx) =>
        idx === index ? { ...item, [fieldName]: value } : item
      )
    );
  };

  /* --------------------- Contact Person Inside Project Details -------- */

  //Add Projects
  const addProjectCantactPersonNew = (projectIndex) => {
    const newContactPerson = {
      id: Date.now(), // Unique ID for each contact person
      projectContactPosition: "",
      projectContactTitle: "",
      projectContactName: "",
      projectContactNumber: "",
      projectContactEmail: "",
    };

    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: [
          ...updatedProjectDetails[projectIndex].getProjectContactPerson,
          newContactPerson,
        ],
      };
      return updatedProjectDetails;
    });
  };

  //Delete Project
  const deleteProjectContactPerosnNew = (projectIndex, id) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.filter((contact) => contact.id !== id),
      };
      return updatedProjectDetails;
    });
  };

  //Project Contact Inputs
  const handleChangeProjectContactsNew = (
    projectIndex,
    contactId,
    fieldName,
    value
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.map(
          (contact) =>
            contact.id === contactId
              ? { ...contact, [fieldName]: value } // Update the specific field
              : contact // Keep other contacts unchanged
        ),
      };
      return updatedProjectDetails;
    });
  };

  //Dropdown
  const handleChangeProjectContactsNewDropdown = (
    projectIndex,
    contactId,
    fieldName,
    value
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Update the specific contact person's field
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectContactPerson: updatedProjectDetails[
          projectIndex
        ].getProjectContactPerson.map(
          (contact) =>
            contact.id === contactId
              ? { ...contact, [fieldName]: value.name } // Update the field with the full object
              : contact // Keep other contacts unchanged
        ),
      };

      return updatedProjectDetails;
    });
  };

  /* ---------------------project Certifications  -------- */

  const deleteProjectCertifications = (projectIndex, certificationId) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Filter out the certification with the specified id
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectCertifications: updatedProjectDetails[
          projectIndex
        ].getProjectCertifications.filter(
          (certification) => certification.id !== certificationId
        ),
      };

      return updatedProjectDetails;
    });
  };

  const addProjectCertifications = (projectIndex) => {
    const newCertification = {
      id: Date.now(), // Unique ID for the new certification
      name: "Document 1",
      documentType: "",
      certificateCode: "29AADCN1012B1Z6",
      stageDocument: "",
    };
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];

      // Add the new certification to the getProjectCertifications array
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectCertifications: [
          ...updatedProjectDetails[projectIndex].getProjectCertifications,
          newCertification,
        ],
      };
      return updatedProjectDetails;
    });
  };

  //document upload for projects
  const onSuccessUploadProjectDocumentType = (
    projectIndex,
    docId,
    fieldName,
    attachmentId
  ) => {
    setProjectDetails((prevData) => {
      const updatedProjectDetails = [...prevData];
      updatedProjectDetails[projectIndex] = {
        ...updatedProjectDetails[projectIndex],
        getProjectCertifications: updatedProjectDetails[
          projectIndex
        ].getProjectCertifications.map((cert) =>
          cert.id === docId ? { ...cert, [fieldName]: attachmentId } : cert
        ),
      };

      return updatedProjectDetails;
    });
  };

  /*documetn type  */

  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
    },
  ]);

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc
      )
    );
  };
  const handleInputChange = (id, fieldName, value) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc
      )
    );
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Vendor Registration Approval Workflow
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {supplierID}
              </span>
            </h2>
            <p className="subText">Vendor Information </p>
            <hr />

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={8} lg={8} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Sumbit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>
            </Row>

            {(formInputs.status === "Non Invited" ||
              formInputs.status === "Invited" ||
              formInputs.status === "In Registration" ||
              formInputs.status === "Reject" ||
              formInputs.status === "Registered") && (
                <>
                  {/* 01 Basic Information */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">BI</span>
                          </Col>
                          <Col xs={12} md={9} lg={9}>
                            <span className="headerTitle">Basic Information</span>
                            <span className="subHeaderTitle">
                              Supplier Basic Information
                            </span>
                          </Col>

                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Supplier Name"
                                name="organisationName"
                                extraLabel="As per the Trade license"
                                placeholder=""
                                value={formInputs.organisationName || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Status"
                                name="status"
                                placeholder=""
                                value={formInputs.status || ""}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Purpose/Justification"
                                type="text"
                                name="purposeJustification"
                                placeholder=""
                                value={formInputs.purposeJustification || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="initiator"
                                name="initiator"
                                placeholder=""
                                value={formInputs.initiator || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="initiator By"
                          name="initiatedBy"
                          placeholder=""
                          value={formInputs.initiatedBy || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col> */}
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="initiator Name"
                                name="initiatorName"
                                placeholder=""
                                value={formInputs.initiatorName || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 02 General Information */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible2
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility2}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">GI</span>
                          </Col>
                          <Col xs={12} md={9} lg={9}>
                            <span className="headerTitle">
                              General Information
                            </span>
                            <span className="subHeaderTitle">
                              Supplier General Information
                            </span>
                          </Col>

                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label=" Name of Company Owner as on license "
                                extraLabel="Name of Company Owner as on license"
                                name="companyOwner"
                                placeholder=""
                                value={formInputs.companyOwner || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Nature of business"
                                // extraLabel="Web site URL /Logo  and Company Brochure Attachment"
                                name="natureOfBusiness"
                                placeholder=""
                                value={formInputs.natureOfBusiness || ""}
                                onChange={onInputChange}
                                disabled={true}
                              //  error={validation.natureOfBusiness}
                              // required={true}
                              />

                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                            >
                              <div className="d-flex flex-column ">
                                <p className="fw-medium m-0 text-nowrap">
                                  Company Brochure
                                </p>

                                {(formInputs?.companyBrochure1 && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.companyBrochure1)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </div>
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Payments Term"
                                placeholder=""
                                // data={PaymentTermsOptions}
                                id="paymentsTerm"
                                iconClassName="dropdownIcon"
                                name="paymentsTerm"
                                // code="supplierTypeCode"
                                // description="supplierTypeDesc"
                                value={formInputs.paymentsTerm}
                                disabled={true}
                              // getvalue={setDropdownData}
                              // error={validation.paymentsTerm}
                              // required={true}
                              />

                            </Col>

                            {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="file"
                              label="Upload Company Logo"
                              name="companyLogo"
                              placeholder=""
                              value={formInputs.companyLogo || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}
                            {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Do you have ISO (9001, 14001, 45001) Certification?"
                          placeholder=""
                          data={dropdownOption}
                          id="rfqCategory"
                          iconClassName="dropdownIcon"
                          name="rfqCategory"
                          setValue={formInputs.rfqCategory || ""}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                        />
                      </Col> */}
                            {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Website and Company Brochure"
                              name="CompanyBrochure"
                              placeholder=""
                              value={formInputs.CompanyBrochure || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                            <div className="col-sm-10">
                              <input
                                className="form-control"
                                type="file"
                                id="formFile"
                              />
                            </div>
                          </Col> */}
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 03 Company Address */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible3
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility3}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CA</span>
                          </Col>
                          <Col xs={12} md={9} lg={9}>
                            <span className="headerTitle">Company Address</span>
                            <span className="subHeaderTitle">
                              Address of the Company
                            </span>
                          </Col>

                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label=" Address Lines 1 / Street"
                                name="address"
                                placeholder=""
                                value={formInputs.address || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Address Line 2"
                                name="address2"
                                placeholder=""
                                value={formInputs.address2 || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="City"
                                name="city"
                                placeholder=""
                                value={formInputs.city || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Country"
                                placeholder=""
                                data={getCountry}
                                id="country"
                                iconClassName="dropdownIcon"
                                name="country"
                                setValue={formInputs.country}
                                getvalue={setDropdownData}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="State / Emirate / Province (Region)"
                                placeholder=""
                                data={getState}
                                id="state"
                                iconClassName="dropdownIcon"
                                name="state"
                                setValue={formInputs.state}
                                getvalue={setDropdownData}
                                disabled={getDisabledStatus}
                              // className="dropdownOption"
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Postal Code/PO Box"
                                name="cityPostalCode"
                                placeholder=""
                                value={formInputs.cityPostalCode || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 04 Contact Person */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible4
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility4}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CP</span>
                          </Col>
                          <Col xs={12} md={8} lg={8}>
                            <span className="headerTitle">Contact Person</span>
                            <span className="subHeaderTitle">
                              Contact Person Details
                            </span>
                          </Col>
                          {/* <Col xs={4} md={2} lg={2} className="">
                          <button
                            className="btnTable"
                            onClick={() => addContactAddress()}
                            disabled={getDisabledStatus}
                          >
                            <i className="bi bi-plus-lg"></i> Add Contact
                          </button>
                        </Col> */}

                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Job Title"
                                placeholder=""
                                data={getJobTitleData}
                                id="contactPosition"
                                iconClassName="dropdownIcon"
                                name="contactPosition"
                                code="contactPositionCode"
                                description="contactPositionDesc"
                                setValue={formInputs.contactPosition}
                                getvalue={setDropdownData}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Contact Title"
                                placeholder=""
                                data={getContactTitleData}
                                id="contactTitle"
                                iconClassName="dropdownIcon"
                                name="contactTitle"
                                code="contactTitleCode"
                                description="contactTitleDesc"
                                setValue={formInputs.contactTitle}
                                getvalue={setDropdownData}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact First Name"
                                name="contactfirstName"
                                placeholder=""
                                value={formInputs.contactfirstName || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact Last Name"
                                name="contactlastName"
                                placeholder=""
                                value={formInputs.contactlastName || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact Email"
                                name="email"
                                placeholder=""
                                value={formInputs.email || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact Number"
                                name="contactNumber"
                                placeholder=""
                                value={formInputs.contactNumber || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Alternate Contact Number"
                                name="alternateContactNumber"
                                placeholder=""
                                value={formInputs.alternateContactNumber || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Alternate Email-ID"
                                name="alternateEmailId"
                                placeholder=""
                                value={formInputs.alternateEmailId || ""}
                                onChange={onInputChange}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 06 Category Selection */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible6
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility6}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CS</span>
                          </Col>
                          <Col xs={12} md={6} lg={6}>
                            <span className="headerTitle">
                              Category Selection
                            </span>
                            <span className="subHeaderTitle">
                              Select Required Category
                            </span>
                          </Col>

                          {/* Condition for VM-TEAM to edit the form */}
                          {getPageBlockStatus && (
                            <>
                              <Col xs={4} md={2} lg={2} className="">
                                <button
                                  className="btnTable"
                                  onClick={() => addCategorySelection()}
                                  disabled={false}
                                >
                                  <i className="bi bi-plus-lg"></i> Add Category
                                </button>
                              </Col>

                              <Col xs={4} md={2} lg={2} className="">
                                <button
                                  className="btnTable"
                                  onClick={() => removeCategory()}
                                  disabled={getDisabledRemove}
                                >
                                  <i className="bi bi-trash3"></i> Remove Category
                                </button>
                              </Col>
                            </>
                          )}

                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col xs={12} md={12} lg={12}>
                              {/* {data.length === 0 && ( */}
                              <DataTable
                                title=""
                                columns={columns}
                                data={initalData}
                                progressPending={loading}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                // paginationServer
                                // paginationTotalRows={totalRows}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                selectableRows
                                onSelectedRowsChange={handleChange}
                              />
                              {/* )} */}

                              {/* {data.length !== 0 && (
                              <DataTable
                                title=""
                                columns={columns}
                                data={data}
                                progressPending={loading}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                // paginationServer
                                // paginationTotalRows={totalRows}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                selectableRows
                                onSelectedRowsChange={handleChange}
                              />
                            )} */}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  {formInputs.supplierTypeCode === "S02" && (
                    <>
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible4
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility4}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">FD</span>
                              </Col>
                              <Col xs={8} md={8} lg={8}>
                                <span className="headerTitle">
                                  Factory Details{" "}
                                </span>
                                <span className="subHeaderTitle">
                                  Factory Details
                                </span>
                              </Col>
                              {/* <Col xs={4} md={2} lg={2}>
                            <div className="d-flex justify-content-end  p-2 me-3">
                              <button
                                className="btnTable"
                                onClick={() => addProjectDetails()}
                              >
                                <i className="bi bi-plus-lg"></i> Add Factory
                              </button>
                            </div>
                          </Col> */}
                            </Row>
                          </h2>
                          <div
                            className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              {Array.isArray(getProjectDetails) &&
                                getProjectDetails?.map((item, index) => (
                                  <div key={index}>
                                    <Row className="pt-2 pb-4">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                                          Factory Details {index + 1}
                                        </h5>
                                        <span
                                          className="deleteIconAccordion"
                                          onClick={() =>
                                            removeProjectDetails(index)
                                          }
                                        >
                                          {" "}
                                          <i className="bi bi-x-circle"></i>{" "}
                                        </span>
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <InputField
                                          className="inputBox"
                                          label="Factory Name"
                                          extraLabel="As per the trade license"
                                          name="projectName"
                                          value={item.projectName || ""}
                                          onChange={(e) =>
                                            handleProjectInputChange(
                                              e.target.value,
                                              index,
                                              "projectName"
                                            )
                                          }
                                          required={true}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <InputField
                                          className="inputBox"
                                          label="Address Lines 1 / Street"
                                          extraLabel="As per the trade license"
                                          name="projectAddress"
                                          value={item.projectAddress || ""}
                                          onChange={(e) =>
                                            handleProjectInputChange(
                                              e.target.value,
                                              index,
                                              "projectAddress"
                                            )
                                          }
                                          required={true}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <InputField
                                          className="inputBox"
                                          label="Address Line 2"
                                          extraLabel="As per the trade license"
                                          name="projectAddress2"
                                          value={item.projectAddress2 || ""}
                                          onChange={(e) =>
                                            handleProjectInputChange(
                                              e.target.value,
                                              index,
                                              "projectAddress2"
                                            )
                                          }
                                          required={true}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <InputField
                                          className="inputBox"
                                          label="City"
                                          extraLabel="As per the trade license"
                                          name="projectCity"
                                          value={item.projectCity || ""}
                                          onChange={(e) =>
                                            handleProjectInputChange(
                                              e.target.value,
                                              index,
                                              "projectCity"
                                            )
                                          }
                                          required={true}
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <ComboboxField
                                          label="Country"
                                          placeholder=""
                                          data={getCountry}
                                          id="projectCountry"
                                          iconClassName="dropdownIcon"
                                          name="projectCountry"
                                          code="projectCountryCode"
                                          description="projectCountryDesc"
                                          setValue={item?.projectCountry}
                                          getvalue={setDropdownData}
                                          index={item.id}
                                          onChangeValue={(value) =>
                                            handleProjectInputChange(
                                              value,
                                              index,
                                              "projectCountry"
                                            )
                                          }
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <ComboboxField
                                          label="State"
                                          placeholder=""
                                          data={getState}
                                          id="projectState"
                                          iconClassName="dropdownIcon"
                                          name="projectState"
                                          code="projectStateCode"
                                          description="projectStateDesc"
                                          setValue={item?.projectState}
                                          getvalue={setDropdownData}
                                          index={item.id}
                                          onChangeValue={(value) =>
                                            handleProjectInputChange(
                                              value,
                                              index,
                                              "projectState"
                                            )
                                          }
                                          disabled={true}
                                        />
                                      </Col>
                                      <Col
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <InputField
                                          className="inputBox"
                                          label="Postal Code/PO Box"
                                          extraLabel="As per the trade license"
                                          name="projectCityPostalCode"
                                          value={item.projectCityPostalCode || ""}
                                          onChange={(e) =>
                                            handleProjectInputChange(
                                              e.target.value,
                                              index,
                                              "projectCityPostalCode"
                                            )
                                          }
                                          required={true}
                                          disabled={true}
                                        />
                                      </Col>
                                    </Row>

                                    <Row>
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <div>
                                          <div className="d-flex-column justify-content-center">
                                            <Row>
                                              <Col xs={12} md={5} lg={5}>
                                                <h5 className="bg-table-status bg-table-warning-status mt-1">
                                                  Factory Contacts
                                                </h5>
                                              </Col>

                                              <Col xs={12}>
                                                <div className="accordion-body">
                                                  <div className="d-flex-column justify-content-center">
                                                    <Row className="pt-4 d-none d-lg-flex ">
                                                      <Col xs={12} md={2} lg={2}>
                                                        <p className="fs-6 fw-medium d-flex ms-4">
                                                          Job Title
                                                        </p>
                                                      </Col>
                                                      <Col xs={12} md={4} lg={2}>
                                                        <p className="fs-6 fw-medium d-flex ms-4">
                                                          Contact Title
                                                        </p>
                                                      </Col>
                                                      <Col xs={12} md={4} lg={2}>
                                                        <p className="fs-6 fw-medium d-flex ms-4">
                                                          Contact Person
                                                        </p>
                                                      </Col>
                                                      <Col xs={12} md={4} lg={2}>
                                                        <p className="fs-6 fw-medium d-flex ms-4">
                                                          Contact Number
                                                        </p>
                                                      </Col>
                                                      <Col xs={12} md={4} lg={2}>
                                                        <p className="fs-6 fw-medium d-flex ms-4">
                                                          Email-ID
                                                        </p>
                                                      </Col>
                                                      {/* <Col xs={12} md={4} lg={2}>
                                                    <p className="fs-6 fw-medium d-flex">
                                                      Action
                                                    </p>
                                                  </Col> */}
                                                    </Row>
                                                    {item?.getProjectContactPerson.map(
                                                      (doc, itemIndex) => (
                                                        <Row key={doc.id}>
                                                          <Col xs={12}>
                                                            <hr className="mx-4 my-0 text-color-black" />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <ComboboxFieldSubArray
                                                              label=""
                                                              placeholder="Job Title"
                                                              data={
                                                                getcontactPosition
                                                              }
                                                              id="projectContactPosition"
                                                              name="projectContactPosition"
                                                              code="projectContactPositionCode"
                                                              description="projectContactPositionDesc"
                                                              disabled={true}
                                                              setValue={
                                                                doc.projectContactPosition
                                                              }
                                                              index={index} // Pass projectIndex instead of doc.id
                                                              onChangeValue={(
                                                                projectIndex,
                                                                contactId,
                                                                fieldName,
                                                                value
                                                              ) =>
                                                                handleChangeProjectContactsNewDropdown(
                                                                  projectIndex,
                                                                  doc.id,
                                                                  fieldName,
                                                                  value
                                                                )
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <ComboboxFieldSubArray
                                                              label=""
                                                              placeholder="Contact Title"
                                                              data={getTitle}
                                                              id="projectContactTitle"
                                                              iconClassName="dropdownIcon"
                                                              name="projectContactTitle"
                                                              code="projectContactTitleCode"
                                                              description="projectContactTitleDesc"
                                                              disabled={true}
                                                              setValue={
                                                                doc.projectContactTitle
                                                              }
                                                              index={index} // Pass projectIndex instead of doc.id
                                                              onChangeValue={(
                                                                projectIndex,
                                                                contactId,
                                                                fieldName,
                                                                value
                                                              ) =>
                                                                handleChangeProjectContactsNewDropdown(
                                                                  projectIndex,
                                                                  doc.id,
                                                                  fieldName,
                                                                  value
                                                                )
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <InputField
                                                              className="inputBox mt-1"
                                                              name="projectContactName"
                                                              placeholder="Contact Person"
                                                              disabled={true}
                                                              value={
                                                                doc.projectContactName ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChangeProjectContactsNew(
                                                                  index,
                                                                  doc.id,
                                                                  "projectContactName",
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <InputField
                                                              className="inputBox mt-1"
                                                              name="projectContactNumber"
                                                              placeholder="Contact Number"
                                                              disabled={true}
                                                              value={
                                                                doc.projectContactNumber ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChangeProjectContactsNew(
                                                                  index,
                                                                  doc.id,
                                                                  "projectContactNumber",
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <InputField
                                                              className="inputBox mt-1"
                                                              name="projectContactEmail"
                                                              placeholder="Email"
                                                              disabled={true}
                                                              value={
                                                                doc.projectContactEmail ||
                                                                ""
                                                              }
                                                              onChange={(e) =>
                                                                handleChangeProjectContactsNew(
                                                                  index,
                                                                  doc.id,
                                                                  "projectContactEmail",
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <div className="d-flex">
                                                              {item
                                                                ?.getProjectContactPerson
                                                                .length !== 1 && (
                                                                  <i
                                                                    onClick={() =>
                                                                      deleteProjectContactPerosnNew(
                                                                        index,
                                                                        doc.id
                                                                      )
                                                                    }
                                                                    className="bi bi-trash text-danger fs-4"
                                                                  />
                                                                )}

                                                              {/* {itemIndex ===
                                                            item
                                                              ?.getProjectContactPerson
                                                              .length -
                                                            1 && (
                                                              <button
                                                                className="btnTable width-40 ml-6 mt-1"
                                                                onClick={() =>
                                                                  addProjectCantactPersonNew(
                                                                    index
                                                                  )
                                                                } // Fixed: Pass as a callback
                                                              >
                                                                <i className="bi bi-plus-lg"></i>{" "}
                                                                Add
                                                              </button>
                                                            )} */}
                                                            </div>
                                                          </Col>
                                                        </Row>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>

                                    <Row>
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <div>
                                          <div className="d-flex-column justify-content-center">
                                            <Row>
                                              <Col xs={12} md={5} lg={5}>
                                                <h5 className="bg-table-status bg-table-warning-status mt-4">
                                                  Factory Stages
                                                </h5>
                                              </Col>
                                              <Col xs={12}>
                                                <div className="accordion-body">
                                                  <div className="d-flex-column justify-content-center">
                                                    <Row className="pt-4 d-none d-lg-flex ">
                                                      <Col xs={12} md={2} lg={2}>
                                                        <p className="fs-6 fw-medium d-flex ms-4">
                                                          Stages
                                                        </p>
                                                      </Col>
                                                      <Col xs={12} md={4} lg={1}>
                                                        <p className="fs-6 fw-medium d-flex ms-4">
                                                          View Files
                                                        </p>
                                                      </Col>
                                                      {/* <Col xs={12} md={4} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex ms-4">
                                                      Attachments
                                                    </p>
                                                  </Col> */}

                                                      {/* <Col xs={12} md={4} lg={3}>
                                                    <p className="fs-6 fw-medium d-flex">
                                                      Action
                                                    </p>
                                                  </Col> */}
                                                    </Row>
                                                    {item.getProjectCertifications.map(
                                                      (doc, itemIndex) => (
                                                        <Row key={doc.id}>
                                                          <Col xs={12}>
                                                            <hr className="mx-4 my-0 text-color-black" />
                                                          </Col>
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={2}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <ComboboxFieldSubArray
                                                              label=""
                                                              placeholder="Stages"
                                                              data={
                                                                productDocumentAttachment
                                                              }
                                                              id="documentType"
                                                              iconClassName="dropdownIcon"
                                                              name="documentType"
                                                              code="documentTypeCode"
                                                              description="documentTypeDesc"
                                                              disabled={true}
                                                              setValue={
                                                                doc.documentType
                                                              }
                                                              index={index} // Pass projectIndex instead of doc.id
                                                              onChangeValue={(
                                                                projectIndex,
                                                                fileId,
                                                                fieldName,
                                                                value
                                                              ) =>
                                                                handleChangeProjectContactsNewDropdown(
                                                                  projectIndex,
                                                                  doc.id,
                                                                  fieldName,
                                                                  value
                                                                )
                                                              }
                                                            />
                                                          </Col>
                                                          {/* <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={1}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <div className="d-flex justify-content-center">
                                                        {(doc.iSOCertification && (
                                                          <img
                                                            src="assets/img/newIcons/attached-file.png"
                                                            className="mt-1 attachmentIcon"
                                                            alt="attachments"
                                                            onClick={() =>
                                                              handleViewFile(
                                                                doc.iSOCertification
                                                              )
                                                            }
                                                          />
                                                        )) ||
                                                          "--"}
                                                      </div>
                                                    </Col> */}
                                                          <Col
                                                            xs={12}
                                                            md={4}
                                                            lg={1}
                                                            className="commTopButtonRightLeftPadding"
                                                          >
                                                            <div className="d-flex justify-content-center">
                                                              {(doc.stageDocument && (
                                                                <img
                                                                  src="assets/img/newIcons/attached-file.png"
                                                                  className="mt-1 attachmentIcon"
                                                                  alt="attachments"
                                                                  onClick={() =>
                                                                    handleViewFile(
                                                                      doc.stageDocument
                                                                    )
                                                                  }
                                                                />
                                                              )) ||
                                                                "--"}
                                                            </div>
                                                          </Col>
                                                        </Row>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>

                                    <Row>
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <div></div>
                                      </Col>
                                    </Row>

                                    <hr />
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                </>
              )}
            {/* customer Doucment Type isCardVisible2 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={9} lg={9}>
                      <span className="headerTitle"> Doucment Type</span>
                      <span className="subHeaderTitle">Doucment Type</span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2}>
                                    <div className="d-flex justify-content-end  p-2 me-3">
                                      <button className="btnTable" onClick={addDocumentType}>
                                        <i className="bi bi-plus-lg"></i> Add
                                      </button>
                                    </div>
                                  </Col> */}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      {/* <Col xs={12} md={4} lg={2}>
                                                      <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                                        Action
                                                      </p>
                                                    </Col> */}
                                    </Row>
                                    {Array.isArray(getDocumentTypeData) && getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                            disabled={getDisabledStatus}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value
                                              )
                                            }
                                            disabled={getDisabledStatus}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={doc.issueDate}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value
                                              )
                                            }
                                            disabled={getDisabledStatus}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={true} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                            disabled={getDisabledStatus}
                                          />
                                        </Col>
                                        {/* <Col
                                                        xs={12}
                                                        md={4}
                                                        lg={1}
                                                        className="commTopButtonRightLeftPadding"
                                                      >
                                                        <i
                                                          onClick={() =>
                                                            deleteDocumentType(doc.id)
                                                          }
                                                          className="bi bi-trash text-danger fs-4"
                                                        />
                                                      </Col> */}
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col
                      xs={1}
                      md={1}
                      lg={1}
                      className="text-left arrowBtn"
                    >
                      <i
                        className={`bi ${isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col
                      xs={1}
                      md={1}
                      lg={1}
                      className="text-center logoBtn"
                    >
                      <span className="iconLogo">FI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Financial Info</span>
                      <span className="subHeaderTitle">
                         Please include all the required financial data.
                      </span>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                {/* Banker Information */}
                <div
                  className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getBankDetails &&
                      getBankDetails?.map((item, index) => (
                        <div key={index}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Bank Information Section {index + 1}</h6>
                              {/* <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                {" "}
                                <i className="bi bi-x-circle"></i>{" "}
                              </span> */}
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Is the Company bank included on list?"
                                placeholder=""
                                data={dropdownOption}
                                id="bankNotListed"
                                iconClassName="dropdownIcon"
                                name="bankNotListed"
                                setValue={item?.bankNotListed || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="BankID"
                                placeholder=""
                                data={getBankDetailsData}
                                id="bankKey"
                                iconClassName="dropdownIcon"
                                name="bankKey"
                                setValue={item?.bankKey}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank A/C Number"
                                name="bankAccountNumber"
                                placeholder=""
                                value={item?.bankAccountNumber}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankAccountNumber",
                                    e.target.value
                                  )
                                }
                                onBlur={(e) =>
                                  handleBankInfo(
                                    index,
                                    "bankAccountNumber",
                                    e.target.value
                                  )
                                }
                                disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Bank Name"
                                placeholder=""
                                data={dropdownOption}
                                id="bankName"
                                iconClassName="dropdownIcon"
                                name="bankName"
                                setValue={item?.bankName || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}

                              <InputField
                                className="inputBox"
                                label="Bank Name"
                                name="bankBranchName"
                                placeholder=""
                                value={item?.bankBranchName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankBranchName",
                                    e.target.value
                                  )
                                }
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Bank Country"
                                placeholder=""
                                data={dropdownOption}
                                id="bankCountry"
                                iconClassName="dropdownIcon"
                                name="bankCountry"
                                setValue={item?.bankCountry || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="Bank Country"
                                name="bankCountryDescription"
                                placeholder=""
                                value={item?.bankCountryDescription}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankCountryDescription",
                                    e.target.value
                                  )
                                }
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Branch Address"
                                placeholder=""
                                data={dropdownOption}
                                id="bankAddress"
                                iconClassName="dropdownIcon"
                                name="bankAddress"
                                setValue={item?.bankAddress || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="Branch Address"
                                name="bankAddress"
                                placeholder=""
                                value={item?.bankAddress}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankAddress",
                                    e.target.value
                                  )
                                }
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Preferred Currency"
                                placeholder=""
                                data={dropdownOption}
                                id="preferredCurrency"
                                iconClassName="dropdownIcon"
                                name="preferredCurrency"
                                setValue={item?.preferredCurrency || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="Preferred Currency"
                                name="bankCurrency"
                                placeholder=""
                                value={item?.bankCurrency}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankCurrency",
                                    e.target.value
                                  )
                                }
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="IBAN"
                                name="iban"
                                placeholder=""
                                value={item?.iban}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "iban",
                                    e.target.value
                                  )
                                }
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name of Beneficiary"
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                name="AccountHolderName"
                                placeholder=""
                                value={item?.AccountHolderName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "AccountHolderName",
                                    e.target.value
                                  )
                                }
                                disabled={getDisabledStatus}
                              />
                              {/* <ComboboxField
                                label="Name of Beneficiary"
                                placeholder=""
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                data={dropdownOption}
                                id="AccountHolderName"
                                iconClassName="dropdownIcon"
                                name="AccountHolderName"
                                setValue={item?.AccountHolderName || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              /> */}
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Swift IFSC Code"
                                placeholder=""
                                data={dropdownOption}
                                id="swiftIfscCode"
                                iconClassName="dropdownIcon"
                                name="swiftIfscCode"
                                setValue={item?.swiftIfscCode || ""}
                                getvalue={setDropdownData}
                                index={index}
                                onChangeValue={handleChangeBankInfo}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Company letterhead"
                                extraLabel="Upload the filled template on company letterhead , signed by authorized person with company seal "
                                name="bankCompanyletterhead"
                                placeholder=""
                                value={item?.bankCompanyletterhead}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankCompanyletterhead",
                                    e.target.value
                                  )
                                }
                                disabled={getDisabledStatus}
                              />
                              {/* <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div> */}
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Confirmation letter"
                                extraLabel="Do you have a Confirmation letter from the bank( mandatory for bank updates ) "
                                name="bankConfirmationLetter"
                                placeholder=""
                                value={item?.bankConfirmationLetter}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "bankConfirmationLetter",
                                    e.target.value
                                  )
                                }
                                disabled={getDisabledStatus}
                              />
                              {/* <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div> */}
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Correspondence Bank Details"
                                extraLabel="Correspondence Bank Details /Chips code/ ACH/ EFT/ ABA/ FED "
                                name="chipsCode"
                                placeholder=""
                                value={item?.chipsCode}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    index,
                                    "chipsCode",
                                    e.target.value
                                  )
                                }
                                disabled={getDisabledStatus}
                              />

                              {/* <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div> */}
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                              >
                                <div className="d-flex flex-column ">
                                  <p className="fw-medium m-0 text-nowrap">
                                    Company Letterhead Attachment
                                  </p>

                                  {(item?.bankCompanyletterhead && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item.bankCompanyletterhead
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                              >
                                <div className="d-flex flex-column ">
                                  <p className="fw-medium m-0 text-nowrap">
                                    Confirmation letter Attachment
                                  </p>

                                  {(item?.bankConfirmationLetter && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankConfirmationLetter
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                              >
                                <div className="d-flex flex-column ">
                                  <p className="fw-medium m-0 text-nowrap">
                                    Correspondence Bank Details Attachment
                                  </p>

                                  {(item?.chipsCode && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(item?.chipsCode)
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>
                            </Row>

                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <hr />
                            </Col>
                          </Row>
                             {/* ===== Section 2: Financial Performance ===== */}
                                        <Row className="pt-2 pb-4">
                                          <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding">
                                            <h6>Section {index + 2}: Financial Performance</h6>
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                                            <InputField
                                              className="inputBox"
                                              label="Year 1 - Turnover"
                                              extraLabel="Year 1 - Company turnover supported by documentary evidence"
                                              name="turnover1"
                                              placeholder=""
                                              value={item.turnover1 || ""}
                                              onChange={(e) => handleChangeBankInfo(index, "turnover1", e.target.value)}
                                              disabled={true}
                                            />
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                                            <InputField
                                              className="inputBox"
                                              label="Year 2 - Turnover"
                                              extraLabel="Year 2 - Company turnover supported by documentary evidence"
                                              name="turnover2"
                                              placeholder=""
                                              value={item.turnover2 || ""}
                                              onChange={(e) => handleChangeBankInfo(index, "turnover2", e.target.value)}
                                              disabled={true}
                                            />
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                                            <InputField
                                              className="inputBox"
                                              label="Year 3 - Turnover"
                                              extraLabel="Year 3 - Company turnover supported by documentary evidence"
                                              name="turnover3"
                                              placeholder=""
                                              value={item.turnover3 || ""}
                                              onChange={(e) => handleChangeBankInfo(index, "turnover3", e.target.value)}
                                              disabled={true}
                                            />
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
                                            {!getDisabledStatus && (
                                              <FileUploadComponent
                                                id="turnover1Atch"
                                                name="turnover1Atch"
                                                label="Year 1 - Turnover"
                                                allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                                multiple={true}
                                                required={true}
                                                // onSuccessUpload={(data) => onSuccessUploadBankDocumentType(data, index)}
                                                value={item?.turnover1Atch || ""}
                                              />
                                            )}
                                            <div className="d-flex align-items-center pe-2">
                                              {(item?.turnover1Atch && (
                                                <img
                                                  src="assets/img/newIcons/attached-file.png"
                                                  className="mt-1 attachmentIcon"
                                                  alt="attachments"
                                                  onClick={() => handleViewFile(item?.turnover1Atch)}
                                                />
                                              )) || "--"}
                                            </div>
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
                                            {!getDisabledStatus && (
                                              <FileUploadComponent
                                                id="turnover2Atch"
                                                name="turnover2Atch"
                                                label="Year 2 - Turnover"
                                                allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                                multiple={true}
                                                required={true}
                                                // onSuccessUpload={(data) => onSuccessUploadBankDocumentType(data, index)}
                                                value={item?.turnover2Atch || ""}
                                              />
                                            )}
                                            <div className="d-flex align-items-center pe-2">
                                              {(item?.turnover2Atch && (
                                                <img
                                                  src="assets/img/newIcons/attached-file.png"
                                                  className="mt-1 attachmentIcon"
                                                  alt="attachments"
                                                  onClick={() => handleViewFile(item?.turnover2Atch)}
                                                />
                                              )) || "--"}
                                            </div>
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
                                            {!getDisabledStatus && (
                                              <FileUploadComponent
                                                id="turnover3Atch"
                                                name="turnover3Atch"
                                                label="Year 3 - Turnover"
                                                allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                                multiple={true}
                                                // onSuccessUpload={(data) => onSuccessUploadBankDocumentType(data, index)}
                                                value={item?.turnover3Atch || ""}
                                              />
                                            )}
                                            <div className="d-flex align-items-center pe-2">
                                              {(item?.turnover3Atch && (
                                                <img
                                                  src="assets/img/newIcons/attached-file.png"
                                                  className="mt-1 attachmentIcon"
                                                  alt="attachments"
                                                  onClick={() => handleViewFile(item?.turnover3Atch)}
                                                />
                                              )) || "--"}
                                            </div>
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding">
                                            <InputField
                                              className="inputBox"
                                              label="Financial Documents Upload"
                                              extraLabel="Upload any additional financial documents"
                                              name="financialDocNote"
                                              placeholder=""
                                              value={item.financialDocNote || ""}
                                              onChange={(e) => handleChangeBankInfo(index, "financialDocNote", e.target.value)}
                                              disabled={true}
                                            />
                                          </Col>
                          
                                          <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
                                            {!getDisabledStatus && (
                                              <FileUploadComponent
                                                id="financialUploadDocument"
                                                name="financialUploadDocument"
                                                label="Financial DOC"
                                                allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                                                multiple={true}
                                                // onSuccessUpload={(data) => onSuccessUploadBankDocumentType(data, index)}
                                                value={item?.financialUploadDocument || ""}
                                              />
                                            )}
                                            <div className="d-flex align-items-center pe-2">
                                              {(item?.financialUploadDocument && (
                                                <img
                                                  src="assets/img/newIcons/attached-file.png"
                                                  className="mt-1 attachmentIcon"
                                                  alt="attachments"
                                                  onClick={() => handleViewFile(item?.financialUploadDocument)}
                                                />
                                              )) || "--"}
                                            </div>
                                          </Col>
                          
                                          <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding">
                                            <hr />
                                          </Col>
                                        </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

                    <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"}`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DN</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Declaration</span>
                      <span className="subHeaderTitle">Additional Information</span>
                    </Col>
                  </Row>
                </h2>
            
                <div className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""}`}>
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
            
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
                        {!getDisabledStatus && (
                          <FileUploadComponent
                            id="conflictInterestDeclaration"
                            name="conflictInterestDeclaration"
                            label="Conflict of Interest Declaration"
                            allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                            multiple={true}
                            required={true}
                            onSuccessUpload={onSuccessUploadfiles}
                            value={formInputs?.conflictInterestDeclaration || ""}
                          />
                        )}
                        {/* <div className="d-flex align-items-center pe-2"> */}
                        <div className="d-flex flex-column align-items-center pe-2">
                          {(formInputs?.conflictInterestDeclaration && (
                            <>
                            <h6>Conflict of Interest Declaration</h6>
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() => handleViewFile(formInputs?.conflictInterestDeclaration)}
                            />
                            </>
                          )) || "--"}
                        </div>
                      </Col>
            
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
                        {!getDisabledStatus && (
                          <FileUploadComponent
                            id="vendorCodeOfConduct"
                            name="vendorCodeOfConduct"
                            label="Vendor Code of Conduct"
                            allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                            multiple={true}
                            required={true}
                            onSuccessUpload={onSuccessUploadfiles}
                            value={formInputs?.vendorCodeOfConduct || ""}
                          />
                        )}
<div className="d-flex flex-column align-items-center pe-2">
                            {(formInputs?.vendorCodeOfConduct && (
                              <>
                              <h6>Vendor Code of Conduct</h6>
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() => handleViewFile(formInputs?.vendorCodeOfConduct)}
                            />
                            </>
                          )) || "--"}
                        </div>
                      </Col>
            
                      <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
                        {!getDisabledStatus && (
                          <FileUploadComponent
                            id="antiBriberyPolicy"
                            name="antiBriberyPolicy"
                            label="Anti-Bribery and Corruption Policy"
                            allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                            multiple={true}
                            onSuccessUpload={onSuccessUploadfiles}
                            value={formInputs?.antiBriberyPolicy || ""}
                          />
                        )}
                        <div className="d-flex flex-column align-items-center pe-2">
                          {(formInputs?.antiBriberyPolicy && (
                            <>
                            <h6>Anti-Bribery and Corruption Policy</h6>
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() => handleViewFile(formInputs?.antiBriberyPolicy)}
                            />
                            </>
                          )) || "--"}
                        </div>
                      </Col>
            
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {(formInputs.status === "In Registration" ||
              formInputs.status === "Invited" ||
              formInputs.status === "Registered") && (
                <>
                  {/* 05 Commodity / Service Details*/}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible5
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility5}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CD</span>
                          </Col>
                          <Col xs={12} md={9} lg={9}>
                            <span className="headerTitle">
                              Commodity / Service Details
                            </span>
                            <span className="subHeaderTitle">
                              Commodity and Service Description
                            </span>
                          </Col>

                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Commodity / services offered"
                                placeholder=""
                                data={dropdownOption}
                                id="commodityServices"
                                iconClassName="dropdownIcon"
                                name="commodityServices"
                                setValue={formInputs.commodityServices || ""}
                                getvalue={setDropdownData}
                                disabled={getDisabledStatus}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>


                  {/* 09 */}
                  
                  {/* 10 */}
                  {/* <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible10
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility10}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CD</span>
                          </Col>
                          <Col xs={12} md={9} lg={9}>
                            <span className="headerTitle">
                              Company Documents & Certificates
                            </span>
                            <span className="subHeaderTitle">
                              Company Documents & Certificates
                            </span>
                          </Col>

                          <Col xs={2} md={1} lg={1} className="">
                            <CommonFillter />
                          </Col>
                        </Row>
                      </h2>

                      <div
                        className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col xs={12} md={12} lg={12}>
                              <DataTable
                                title=""
                                columns={companyDocumentsCol}
                                data={formInputs.certifications}
                                progressPending={loading}
                                paginationRowsPerPageOptions={
                                  Constants.ROW_PER_PAGE
                                }
                                pagination
                                // paginationServer
                                // paginationTotalRows={totalRows}
                                // onChangeRowsPerPage={handlePerRowsChange}
                                // onChangePage={handlePageChange}
                                selectableRows
                              // onSelectedRowsChange={handleChange}
                              />
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="accordion mb-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <Row className="accordion-button">
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-left arrowBtn"
                          >
                            <i
                              className={`bi ${isCardVisible10
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                }`}
                              onClick={toggleCardVisibility10}
                            ></i>
                          </Col>
                          <Col
                            xs={1}
                            md={1}
                            lg={1}
                            className="text-center logoBtn"
                          >
                            <span className="iconLogo">CD</span>
                          </Col>

                          <Col xs={4} md={8} lg={8}>
                            <span className="headerTitle">
                              {" "}
                              Company Documents & Certificates{" "}
                            </span>
                            <span className="subHeaderTitle">
                              Company Documents & Certificates details
                            </span>
                          </Col>
                          {/* <Col xs={4} md={2} lg={2}>
                                                            <div className="d-flex justify-content-end  p-2 me-3">
                                                              <button
                                                                className="btnTable"
                                                                // onClick={CertificatesaddDocument}
                                                              >
                                                                Add Document
                                                              </button>
                                                            </div>
                                                          </Col> */}
                          <Col xs={1} md={1} lg={1}>
                            {/* <POCollabrationCommonFillter /> */}
                          </Col>
                        </Row>
                      </h2>

                      <div
                        // id="acc"
                        className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                          }`}
                      >
                        <div className="accordion-body">
                          <Row>
                            <Col xs={12} md={12} lg={12}>
                              <div className="accordion-body">
                                <div className="d-flex-column justify-content-center">
                                  <Row>
                                    <Col xs={12}>
                                      <div className="accordion-body">
                                        <div className="d-flex-column justify-content-center">
                                          <Row className="pt-4 d-none d-md-flex">
                                            <Col md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex justify-content-center">
                                                Document Type
                                              </p>
                                            </Col>
                                            <Col md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Document Number
                                              </p>
                                            </Col>
                                            <Col md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-4">
                                                Expiration Date
                                              </p>
                                            </Col>
                                            <Col md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex ms-3">
                                                View Files
                                              </p>
                                            </Col>
                                            <Col md={4} lg={2}>
                                              <p className="fs-6 fw-medium d-flex justify-content-center">
                                                Attachments
                                              </p>
                                            </Col>
                                            {/* <Col md={4} lg={2}>
                                                                              <p className="fs-6 fw-medium d-flex justify-content-center">
                                                                                Action
                                                                              </p>
                                                                            </Col> */}
                                          </Row>

                                          {getCertificateData?.map(
                                            (doc, index) => (
                                              <Row key={doc.id}>
                                                <Col xs={12}>
                                                  <hr className="mx-4 my-0 text-color-black" />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <ComboboxField
                                                    label=""
                                                    placeholder="Document type"
                                                    // data={getdocumentType}
                                                    id="documentType"
                                                    iconClassName="dropdownIcon"
                                                    name="documentType"
                                                    code="documentTypeCode"
                                                    description="documentTypeDesc"
                                                    setValue={doc?.documentType}
                                                    getvalue={setDropdownData}
                                                    index={doc.id}
                                                  // onChangeValue={
                                                  //   handleInputChangeCertificate
                                                  // }
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox"
                                                    placeholder="Document Number"
                                                    value={doc.documentNumber}
                                                  // onChange={(e) =>
                                                  //   handleInputChangeCertificate(
                                                  //     doc.id,
                                                  //     "documentNumber",
                                                  //     e.target.value,
                                                  //     doc.type
                                                  //   )
                                                  // }
                                                  // error={
                                                  //   validation?.[
                                                  //     `${doc.id}_documentNumber`
                                                  //   ]
                                                  // }
                                                  />
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={2}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <InputField
                                                    className="inputBox"
                                                    type="date"
                                                    value={doc.expirationDate}
                                                    // onChange={(e) =>
                                                    //   handleInputChangeCertificate(
                                                    //     doc.id,
                                                    //     "expirationDate",
                                                    //     e.target.value
                                                    //   )
                                                    // }
                                                    disabled={true}
                                                  />
                                                </Col>

                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={1}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <div className="d-flex justify-content-center">
                                                    {(doc.iSOCertification && (
                                                      <img
                                                        src="assets/img/newIcons/attached-file.png"
                                                        className="mt-1 attachmentIcon"
                                                        alt="attachments"
                                                        onClick={() =>
                                                          handleViewFile(
                                                            doc.iSOCertification
                                                          )
                                                        }
                                                      />
                                                    )) ||
                                                      "--"}
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={4}
                                                  lg={3}
                                                  className="commTopButtonRightLeftPadding"
                                                >
                                                  <FileUploadComponent
                                                    id={doc.id}
                                                    name="iSOCertification"
                                                    label=""
                                                    allowedTypes={[
                                                      "image/png",
                                                      "image/jpeg",
                                                      "application/pdf",
                                                    ]}
                                                    multiple={true} // Change to `false` for single file selection
                                                    // required={true}
                                                    disabled={true}
                                                    // onSuccessUpload={
                                                    //   onSuccessUploadDocumentFileTypes
                                                    // }
                                                    value={
                                                      doc.iSOCertification || ""
                                                    }
                                                  />
                                                </Col>
                                                {/* <Col
                                                                                  xs={12}
                                                                                  md={4}
                                                                                  lg={1}
                                                                                  className="commTopButtonRightLeftPadding"
                                                                                >
                                                                                  <i
                                                                                    onClick={() =>
                                                                                      deleteCertificatesDocument(
                                                                                        doc.id
                                                                                      )
                                                                                    }
                                                                                    className="bi bi-trash text-danger fs-4"
                                                                                  />
                                                                                </Col> */}
                                              </Row>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>

                  {formInputs.supplierTypeCode !== "S01" && (
                    <>
                      {/* 11 */}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible11
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility11}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">BM</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  Business Continuity Management
                                </span>
                                <span className="subHeaderTitle">
                                  Business Continuity Management
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible11 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Does your Company have a Business Continuity Management (BCM) Plan / Policy"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="BCMPlanPolicy"
                                    iconClassName="dropdownIcon"
                                    name="BCMPlanPolicy"
                                    setValue={formInputs.BCMPlanPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 12 */}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible12
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility12}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">BI</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  Business & Brand Information
                                </span>
                                <span className="subHeaderTitle">
                                  Category Specific Information
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible12 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Dealership Set-up Type"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="dealershipSetupType"
                                    iconClassName="dropdownIcon"
                                    name="dealershipSetupType"
                                    setValue={
                                      formInputs.dealershipSetupType || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="MRO commodity / category for the selected brand "
                                    placeholder=""
                                    data={dropdownOption}
                                    id="MROcommoditybrand"
                                    iconClassName="dropdownIcon"
                                    name="MROcommoditybrand"
                                    setValue={formInputs.MROcommoditybrand || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    type="text"
                                    label="Brand Name"
                                    id="brandName"
                                    name="brandName"
                                    placeholder=""
                                    value={formInputs.brandName}
                                    onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* 13 */}
                      {/* <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible13
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility13}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">CI</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  Category Specific Information
                                </span>
                                <span className="subHeaderTitle">
                                  Category Specific Information
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible13 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have ISO 17025 certificate?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="havingIso17025"
                                    iconClassName="dropdownIcon"
                                    name="havingIso17025"
                                    setValue={formInputs.havingIso17025 || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have qualified safety officer?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="safetyReqs"
                                    iconClassName="dropdownIcon"
                                    name="safetyReqs"
                                    setValue={formInputs.safetyReqs || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have ISO 45001 certificate?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="iso45001certificate"
                                    iconClassName="dropdownIcon"
                                    name="iso45001certificate"
                                    setValue={
                                      formInputs.iso45001certificate || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have ISO 9001 certificate?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="iso9001certificate"
                                    iconClassName="dropdownIcon"
                                    name="iso9001certificate"
                                    setValue={formInputs.iso9001certificate || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have ISO 14001 certificate?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="iso14001certificate"
                                    iconClassName="dropdownIcon"
                                    name="iso14001certificate"
                                    setValue={
                                      formInputs.iso14001certificate || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have Power of Attorney Certificate?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="PoAinstituteIssued"
                                    iconClassName="dropdownIcon"
                                    name="PoAinstituteIssued"
                                    setValue={formInputs.PoAinstituteIssued || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have a company HSE Management System manual?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="isHseManagementManual"
                                    iconClassName="dropdownIcon"
                                    name="isHseManagementManual"
                                    setValue={
                                      formInputs.isHseManagementManual || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have a procedure for HSE Auditing and Inspection?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="haveHseAuditProcedure"
                                    iconClassName="dropdownIcon"
                                    name="haveHseAuditProcedure"
                                    setValue={
                                      formInputs.haveHseAuditProcedure || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Does your organization have a skills and competency training/development system in place (Technical and HSE)?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="haveSkillTrainingSystem"
                                    iconClassName="dropdownIcon"
                                    name="haveSkillTrainingSystem"
                                    setValue={
                                      formInputs.haveSkillTrainingSystem || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                  <div className="col-sm-10">
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="formFile"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* 14 */}
                      {/* <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible14
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility14}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">RS</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  Responsible Sourcing
                                </span>
                                <span className="subHeaderTitle">
                                  Category Specific Information
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible14 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you stay up to date with local laws / regulations and any changes to ensure that your supply chain is compliant with environmental and ethical laws?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="alignedWithScComplianceEthics"
                                    iconClassName="dropdownIcon"
                                    name="alignedWithScComplianceEthics"
                                    setValue={
                                      formInputs.alignedWithScComplianceEthics ||
                                      ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have a written Business Ethics or business integrity policy/ procedure or Code of Conduct in place?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="haveWrittenCodeOfConduct"
                                    iconClassName="dropdownIcon"
                                    name="haveWrittenCodeOfConduct"
                                    setValue={
                                      formInputs.haveWrittenCodeOfConduct || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have a written policy/procedure on prohibiting bribery, corruption and fraud within your business?"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="haveWrittenPolicyOnAntiCorruption"
                                    iconClassName="dropdownIcon"
                                    name="haveWrittenPolicyOnAntiCorruption"
                                    setValue={
                                      formInputs.haveWrittenPolicyOnAntiCorruption ||
                                      ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Do you have a written procedure to assess and address risk across your supply chain? "
                                    placeholder=""
                                    data={dropdownOption}
                                    id="haveWrittenRiskAssesProcessInSc"
                                    iconClassName="dropdownIcon"
                                    name="haveWrittenRiskAssesProcessInSc"
                                    setValue={
                                      formInputs.haveWrittenRiskAssesProcessInSc ||
                                      ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label=" Are you involved in projects or efforts to improve the local community"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="involvedInLocalCommunityProjects"
                                    iconClassName="dropdownIcon"
                                    name="involvedInLocalCommunityProjects"
                                    setValue={
                                      formInputs.involvedInLocalCommunityProjects ||
                                      ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* 15 */}
                      {/* <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible15
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility15}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">HR</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">Human Rights</span>
                                <span className="subHeaderTitle">
                                  For which of the following working conditions
                                  and human rights issues does your company have a
                                  policy/procedure in place?
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible15 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Child Labour"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="ChildLabourPolicy"
                                    iconClassName="dropdownIcon"
                                    name="ChildLabourPolicy"
                                    setValue={formInputs.ChildLabourPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Working hours / Remuneration"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="WorkingHoursPolicy"
                                    iconClassName="dropdownIcon"
                                    name="WorkingHoursPolicy"
                                    setValue={formInputs.WorkingHoursPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Conflict minerals and indigenous people"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="ConflictMineralsIndigenousPeople"
                                    iconClassName="dropdownIcon"
                                    name="ConflictMineralsIndigenousPeople"
                                    setValue={
                                      formInputs.ConflictMineralsIndigenousPeople ||
                                      ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Discrimination at work"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="DiscriminationAtWorkPolicy"
                                    iconClassName="dropdownIcon"
                                    name="DiscriminationAtWorkPolicy"
                                    setValue={
                                      formInputs.DiscriminationAtWorkPolicy || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Freedom of association"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="FreedomOfAssociationPolicy"
                                    iconClassName="dropdownIcon"
                                    name="FreedomOfAssociationPolicy"
                                    setValue={
                                      formInputs.FreedomOfAssociationPolicy || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Communication in a language that is fully understood by your employees"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="CommuncationFullyUnderstood"
                                    iconClassName="dropdownIcon"
                                    name="CommuncationFullyUnderstood"
                                    setValue={
                                      formInputs.CommuncationFullyUnderstood || ""
                                    }
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Forced labour"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="ForcedLabourPolicy"
                                    iconClassName="dropdownIcon"
                                    name="ForcedLabourPolicy"
                                    setValue={formInputs.ForcedLabourPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Harassment"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="HarassmentPolicy"
                                    iconClassName="dropdownIcon"
                                    name="HarassmentPolicy"
                                    setValue={formInputs.HarassmentPolicy || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* 16 */}
                      {/* <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible16
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility16}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">ES</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  Environmental Stewardship
                                </span>
                                <span className="subHeaderTitle">
                                  For which of the following do you conduct
                                  environmental impact assessment?
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible16 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Biodiversity"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="biodiversity"
                                    iconClassName="dropdownIcon"
                                    name="biodiversity"
                                    setValue={formInputs.biodiversity || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Energy consumption"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="energyConsumption"
                                    iconClassName="dropdownIcon"
                                    name="energyConsumption"
                                    setValue={formInputs.energyConsumption || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Waste generation"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="wasteGeneration"
                                    iconClassName="dropdownIcon"
                                    name="wasteGeneration"
                                    setValue={formInputs.wasteGeneration || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Climate change"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="climateChange"
                                    iconClassName="dropdownIcon"
                                    name="climateChange"
                                    setValue={formInputs.climateChange || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Water consumption"
                                    placeholder=""
                                    data={dropdownOption}
                                    id="waterConsumption"
                                    iconClassName="dropdownIcon"
                                    name="waterConsumption"
                                    setValue={formInputs.waterConsumption || ""}
                                    getvalue={setDropdownData}
                                    disabled={getDisabledStatus}
                                  // className="dropdownOption"
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* 17 */}
                      {/* <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${isCardVisible17
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                    }`}
                                  onClick={toggleCardVisibility17}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">SI</span>
                              </Col>
                              <Col xs={12} md={9} lg={9}>
                                <span className="headerTitle">
                                  SAP Information
                                </span>
                                <span className="subHeaderTitle">
                                  SAP Information of Supplier
                                </span>
                              </Col>

                              <Col xs={2} md={1} lg={1} className="">
                                <CommonFillter />
                              </Col>
                            </Row>
                          </h2>

                          <div
                            className={`accordion-collapse collapse show ${isCardVisible17 ? "visible" : ""
                              }`}
                          >
                            <div className="accordion-body">
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="SAP ID"
                                    name="sapAssociateNumber"
                                    extraLabel="SAP Vendor ID"
                                    placeholder=""
                                    value={formInputs.sapAssociateNumber || ""}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Account Group"
                                    name="accountGroup"
                                    placeholder=""
                                    value={formInputs.accountGroup || ""}
                                    onChange={onInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Company Code"
                                    extraLabel="SAP Company Code"
                                    placeholder=""
                                    id="companyCode"
                                    iconClassName="dropdownIcon"
                                    name="companyCode"
                                    setValue={formInputs.companyCode || ""}
                                    getvalue={setDropdownData}
                                    onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Purchase Organization"
                                    extraLabel="SAP Purchase organization"
                                    placeholder=""
                                    id="purchaseOrg"
                                    iconClassName="dropdownIcon"
                                    name="purchaseOrg"
                                    setValue={formInputs.purchaseOrg || ""}
                                    onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </>
                  )}
                </>
              )}
          </div>
        </Col>
      </Row>

      <CategorySelectionModal
        show={modalShowCat}
        onHide={() => hideModalCat()}
        onselectedcatdata={getSelectedCatData}
      />

      <ApproveRemarksModal
        show={modalShow}
        onHide={() => hideModal()}
        onvaluechange={handleValueChange}
      />

      {/* Success Modal */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default VendorDetailedPageWorkflow;
